import {
  IconChevronDown,
  KeyboardlessInput,
  type KeyboardlessInputProps,
  Stack,
  useIsDropdownListVisible,
} from '@adc/parallax-component-library';

type DropdownInputProps = Omit<
  KeyboardlessInputProps,
  'isFocused' | 'inlineIconConfig'
>;

export const DropdownInput = (dropdownProps: DropdownInputProps) => {
  const isDropdownOpen = useIsDropdownListVisible();

  return (
    <KeyboardlessInput
      {...dropdownProps}
      isFocused={isDropdownOpen}
      inlineIconConfig={{
        icon: isDropdownOpen ? (
          <Stack rotateX="180deg">
            <IconChevronDown color="$interactive.core.enabled" />
          </Stack>
        ) : (
          <IconChevronDown />
        ),
        color: '$interactive.core.enabled',
      }}
    />
  );
};
